import { Component, ElementRef, OnInit, Input, ViewChild, Output, AfterViewInit, EventEmitter, ViewEncapsulation, Renderer2, ChangeDetectorRef, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { State, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { v_DispatchNoteBus } from '../../shared/models/v_DispatchNoteBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DispatchNoteBus } from '@app/cp/shared/models/DispatchNoteBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DQOIReferenceData } from '../../shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '../../shared/base-components/base-dqoi.component';
import * as _ from 'lodash';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subscription, Subject, fromEvent } from 'rxjs';
import { CommonFunctions } from '../../shared/static/common-functions';
import { DateFunctions } from '../../shared/static/date-functions';
import { ColumnComponent } from '@progress/kendo-angular-excel-export';
import { DQOIMessage } from '../../shared/models/DQOIMessage';
import { MessageType } from '../../shared/enums/MessageType';
import { OrderService } from '../../shared/services/order.service';
import { OrderNotesBus } from '../../shared/models/OrderNotesBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { GridEditModes } from '@app/cp/shared/static/CommonValues';

@Component({
    selector: 'order-notes',
    templateUrl: './order-notes.component.html',
    styleUrls: ['./order-notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderNotesComponent extends BaseGridEditFormLinesComponent<OrderNotesBus, null, OrderService> {
    @Input() IsInjury: boolean = false;
    @Input() canEditOthersNotes: boolean = false;
    @Input() displayRows: number;
    @Output() dqoiMessage: EventEmitter<DQOIMessage> = new EventEmitter<DQOIMessage>();
    //get referenceData(): DQOIReferenceData {
    //    return BaseDQOIComponent._referenceData;
    //}
    isTechnician: boolean = false;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private currentSubscription: Subscription;
    private destroy$ = new Subject();

    get rowstoDisplay(): number {
        if (this.displayRows) { return this.displayRows; }
        return this.pageSizeNoPaging;
    }
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, private zone: NgZone, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "OrderNotesBus";
        this.appCode = "OrderNotes";
        this.appName = "Order Notes";
        this.disableCpSearchDialog();
        this.callSaveIndividualInsteadOfSave = true;
    //    this.isTechnician = this.referenceData.isTechnician(this.globals.personId);
    }
    canEditRow(dataItem: OrderNotesBus, column: ColumnComponent) {
        let canEdit = super.canEditRow(dataItem);
        //if (column.field == "visibleToCustomer") { canEdit = false; }
        return canEdit;
    }
    ngAfterViewInit() {
        this.isTechnician = this.referenceData.isTechnician(this.globals.personId);
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'orderNotesId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'notes': new UntypedFormControl(),
            'printable': new UntypedFormControl(),
            'orderNotesPersonId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),

        });
    }
    setForm() {

        this.editForm.patchValue({
            orderNotesId: this.selectedData.orderNotesId,
            orderId: this.selectedData.orderId,
            notes: this.selectedData.notes,
            printable: this.selectedData.printable,
            dispatchNotesPersonId: this.selectedData.orderNotesPersonId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
         });
        this.notes = CommonFunctions.getStringValueIfNull(this.selectedData.notes);
    //    if (this._notesElemRef) {
    //        this._notesElemRef.nativeElement.value = CommonFunctions.getStringValueIfNull(this.selectedData.dispatchNotes);
    //    }
    }
    setFromReferenceData(data: OrderNotesBus) {
        data.personName = this.personName(data.orderNotesPersonId);
        return data;
    }
    setFromNonFormData(data: OrderNotesBus) {
        data.notes = this.notes;
         return data;
    }
    notesPersonId(dataItem: OrderNotesBus = null): any {
        dataItem = !dataItem ? this.selectedData : dataItem;
        return dataItem ? dataItem.orderNotesPersonId : null;
    }
    //onAfterValueChanged(e: any) {
    //    this.dispatchNotes = e;
    //}
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].personName) {
                    this.gridData[i].personName = this.personName(this.gridData[i].orderNotesPersonId);
                }
            }
        }
       this.getDragReady();
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.workOrderNotesGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(takeUntil(this.destroy$)).pipe(
                tap(({ dataTransfer }) => {
                    try {

                        //const dragImgEl = document.createElement('span');
                        //dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
                        //document.body.appendChild(dragImgEl);
                        //dataTransfer.setDragImage(dragImgEl, 0, 0);
                    } catch (err) {
                        // IE doesn't support setDragImage
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
                //   dataItem.dragging = true;
            }));

            //sub.add(dragOver.subscribe((e: any) => {
            //    e.preventDefault();
            //    const dataItem = this.gridData.data.splice(draggedItemIndex, 1)[0];
            //    const dropIndex = closest(e.target, tableRow).rowIndex;
            //    const dropItem = this.gridData.data[dropIndex];

            //    draggedItemIndex = dropIndex;
            //    this.zone.run(() =>
            //       // this.gridData.data.splice(dropIndex, 0, dataItem)
            //    );
            //}));

            sub.add(dragEnd.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 4;
                event.dropid = event.dispatchNotesId

                this.dropEvent.emit(event);
                // const dataItem = this.gridData.data[draggedItemIndex];
                //   dataItem.dragging = false;
            }));
        });

        return sub;
    }

    protected getChangedObject(dataObj: OrderNotesBus) {
        let busObj: OrderNotesBus = new OrderNotesBus(dataObj);
        busObj.notes = dataObj.notes;
        busObj.setBeforeSave();
      //busObj.

        return busObj;
    }

    saveIndividual(dataObj: OrderNotesBus): Promise<BaseMessageInfo> {
        let busObj: OrderNotesBus = this.getChangedObject(dataObj);
        var isAdded = busObj.isAdded;
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.noteSave(busObj).toPromise().then((data: OrderNotesBus) => {
                console.log("note-save-ind-as-a: ", data);
                if (data != null) {
                    let newDataObj: OrderNotesBus = new OrderNotesBus();
                    console.log("note-save-ind-as-b: ", newDataObj, data);
                    newDataObj.setFromBusobj(data);
                    if (data.insertDt == data.updateDt) {
                        newDataObj.insertDt = DateFunctions.getDateNow();
                        newDataObj.updateDt = newDataObj.insertDt; }
                    else {
                        newDataObj.updateDt = DateFunctions.getDateNow();

                    }
                    newDataObj.notes = data.notes;
                    newDataObj = this.setFromReferenceData(newDataObj);
                    retInfo.primaryReturn = newDataObj;
                    this.notify(this.appCode + " Saved Successfully!");
                    let dMmessage: DQOIMessage = new DQOIMessage();

                    dMmessage.messageData = this.parentId;
                    dMmessage.messageType = MessageType.childSaved;
                    this.dqoiMessage.emit(dMmessage);
                }
                else {
                    retInfo.message = "Error Saving"
                    retInfo.saveError = true;
                    this.saveError(null, retInfo.message);
                }
                this.dataLoading = false;
                if (this.GridEditMode === GridEditModes.editButton) {
                    this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
                }
                resolve(retInfo);
            });
        });
    }
    //protected save(dataObj: v_DispatchNoteBus) {

    //    let busObj: DispatchNoteBus = this.getChangedObject(dataObj);
    //    var isAdded = busObj.isAdded;
    //    //   busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
    //    //   busObj.setParentId(this._parentId);
    //    //  data.referenceId = this._parentId;

    //    this.svc_data.saveNote(busObj).subscribe((data: DispatchNoteBus) => {
    //        if (data != null) {
    //            let newDataObj: v_DispatchNoteBus = new v_DispatchNoteBus();
    //            newDataObj.setFromBusobj(data);
    //            newDataObj.dispatchNotes = data.dispatchNotes1;
    //            newDataObj = this.setFromReferenceData(newDataObj);

    //            this.removeLocalAdded();
    //            //if (isAdded)
    //            //{
    //            //    this.gridData.splice(0, 0, newDataObj);
    //            //    this.cd.detectChanges();
    //            //}
    //            //newDataObj.visibleToCustomer = data.visibleToCustomer;
    //
    //            this.saveSuccess(newDataObj);
    //           // this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
    //        }
    //        else {
    //            this.saveError(dataObj, "Error Saving");
    //        }
    //    });
    //}

    deleteIndividual(data: OrderNotesBus) {
        if (data.hasId) {
            this.svc_data.deleteNote(data.orderNotesId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    let delDataObj: OrderNotesBus = new OrderNotesBus(data);
                    this.deleteSuccess(delDataObj);
                    this.removeLocal(delDataObj);
                    this.cd.detectChanges();
                    //this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    // get canEditNote(): boolean {
    //    let can: boolean = false;

    //    if (this.canEdit && this.selectedData) {
    //        if (this.selectedData.dispatchNotesPersonId == this.globals.personId || this.rights.EditOthersNotes) {
    //            can = true;
    //        }
    //    }

    //    return can;
    //}
    //canShowEditButton(dataItem: v_DispatchNoteBus) {
    //    let can: boolean = false;

    //    if (this.canEdit && dataItem) {
    //        if (dataItem.dispatchNotesPersonId == this.globals.personId || this.rights.EditOthersNotes) {
    //            can = true;
    //        }
    //    }

    //    return can;

    //}
    //canDeleteNote(dataItem: v_DispatchNoteBus): boolean {
    //    let can: boolean = false;

    //    if (this.canEdit && dataItem) {
    //        if (dataItem.dispatchNotesPersonId == this.globals.personId || this.rights.EditOthersNotes) {
    //            can = true;
    //        }
    //    }

    //    return can;
    //}
    test() {
        console.log("wo-notes: ", this.canEdit, this.canEditNote, this.selectedData, this.rights.EditOthersNotes, this);
    }
    //dispatchNotes: string;
    //instantSaveCBChanged()
    instantSaveCBChanged(e: any, dataItem: OrderNotesBus, rowIndex, column, columnIndex, setEditMode: boolean = true) {
        if (column.field == "visibleToCustomer") {

            this.saveIndividual(dataItem);
        }
    //    let row_isEdited: boolean = CommonFunctions.hasValue(this.editedRowIndex) && this.editedRowIndex === rowIndex;
    //    if (!row_isEdited && setEditMode) {
    //        this.cellClickHandler({ isEdited: row_isEdited, dataItem: dataItem, rowIndex: rowIndex, column: column, columnIndex: columnIndex });
    //        this.customCheckBoxChanged(e, dataItem, rowIndex, column, columnIndex, setEditMode);
    //        this.setDirty();
    //    }
    //    else {
    //        this.customCheckBoxChanged(e, dataItem, rowIndex, column, columnIndex, setEditMode);
    //    }
    }

}

